import env from '../core/env'

import {
  setShareOutApp,
  invokeShareOutApp
} from './share.outapp'
import {
  setShareInApp,
  invokeShareInApp
} from './share.inapp'

let setShare, invokeShare

if (env.is('passenger, driver')) {
  setShare = setShareInApp
  invokeShare = invokeShareInApp
} else {
  setShare = setShareOutApp
  invokeShare = invokeShareOutApp
}

export default {
  setShare,
  invokeShare
}
